module.exports = __webpack_public_path__ + "static/img/年度最佳轿车.731fdb61.png";